/* ==========================================================================
   The Hush Hush Charter — landing page CTA
   Adds the picked Charter product to the cart and goes straight to checkout.
   Progressive enhancement: the buttons already carry a /cart/<variant>:1
   permalink href, so they work with JS disabled — this just upgrades the
   click to an add + checkout that preserves any existing cart items.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-charter]');
    if (!root) return;
    var variantId = root.getAttribute('data-charter-variant');
    var buttons = root.querySelectorAll('[data-charter-cta]');
    if (!buttons.length) return;

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function (e) {
        // No variant resolved → let the href (permalink or '#') do its thing.
        if (!variantId) return;
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');

        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('charter add failed: ' + res.status);
            return res.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('[hush-charter]', err);
            btn.removeAttribute('aria-busy');
            // Fall back to the permalink href so the purchase can still happen.
            var href = btn.getAttribute('href');
            if (href && href !== '#') window.location.href = href;
          });
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-init when re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-charter]')) init();
  });
})();
